// extracted by mini-css-extract-plugin
module.exports = {"Reveal":"Reveals_Reveal__17dc6","Show":"Reveals_Show__3CpMT","showAnim":"Reveals_showAnim__2OluL","Static":"Reveals_Static__2U7Xk"};